module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputContainer"
  }, [_c('p', [_vm._v(_vm._s(_vm.text) + " de la nouvelle grille à créer :\n        "), _c('input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.model
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e6ec4fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputContainer/InputContainer.vue
// module id = 26
// module chunks = 1